import { render, staticRenderFns } from "./Lgx196046153584738304.vue?vue&type=template&id=65fd4329&scoped=true&"
import script from "./Lgx196046153584738304.vue?vue&type=script&lang=js&"
export * from "./Lgx196046153584738304.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd4329",
  null
  
)

export default component.exports